import Button from '../shared/components/buttons';
import { FC, useCallback, useEffect, useRef } from 'react';
import { LDN_CG_VENUE_ID, NY_HQ_VENUE_ID, PageProps } from '../shared/defines';
import { useNavigate } from 'react-router-dom';
import { TextDecoder } from '../shared/text-effects/TextDecoder';
import { useTextSize } from '../shared/hooks/useTextSize';
import { useSetRecoilState } from 'recoil';
import { venueIdState } from '../state/parent-details';

const SignPage: FC<PageProps> = ({ title }) => {
  const btnRef = useRef<HTMLButtonElement>(null);
  const navigate = useNavigate();

  const hiddenRef = useRef<HTMLHeadingElement>(null);
  const { height: titleHeight } = useTextSize(hiddenRef);
  const setVenueId = useSetRecoilState(venueIdState);

  const handleEnter = useCallback((event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      btnRef.current?.click();
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleEnter);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('keydown', handleEnter);
    };
  }, [handleEnter]);

  const onContinueButtonClick = () => {
    navigate('/email');
  };

  const onContinueNYButtonClick = () => {
    setVenueId(NY_HQ_VENUE_ID);
    onContinueButtonClick();
  };

  const onContinueLondonButtonClick = () => {
    setVenueId(LDN_CG_VENUE_ID);
    onContinueButtonClick();
  };

  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <div className="w-full flex-1 items-center flex gap-10">
      <div className="flex flex-col relative">
        <div
          className="whitespace-normal w-full"
          style={{ height: `${titleHeight}px` }}
        >
          <TextDecoder
            className="font-aeonik font-medium text-[2.125rem]/[2.125rem] sm:text-[3.1rem]/[3.4rem] gap-5"
            delay={0}
            duration={500}
            animationType={'in'}
            text="Parent/Guardian approval required"
          />
        </div>
        <h1
          className="absolute opacity-0 top-0 pointer-events-none font-aeonik font-medium text-[2.125rem]/[2.125rem] sm:text-[3.1rem]/[3.4rem]"
          ref={hiddenRef}
        >
          Parent/Guardian approval required
        </h1>

        <div className="text-[1.25rem]/[1.6rem] font-medium mt-10">
          Please complete the waiver for any child attending SPYGAMES
        </div>

        <div className="text-[1.25rem]/[1.6rem] font-medium mt-10">
          My child is visiting SPYGAMES...
        </div>

        <div className="flex flex-row gap-5">
          <Button
            variant="filled"
            size="sm"
            className="mt-10 text-[1.2rem] w-full sm:w-58 "
            onClick={onContinueNYButtonClick}
          >
            New York
          </Button>

          <Button
            variant="filled"
            size="sm"
            className="mt-10 text-[1.2rem] w-full sm:w-58 "
            onClick={onContinueLondonButtonClick}
          >
            London
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SignPage;
